var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFeatherUploadCloudIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 54,
    viewBox: "0 0 48 54",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32 36.1428L24 27.2856L16 36.1428",
    stroke: "black",
    strokeOpacity: 0.4,
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24 27.2856V47.2142",
    stroke: "black",
    strokeOpacity: 0.4,
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M40.7809 41.435C42.7316 40.2576 44.2726 38.3945 45.1606 36.1398C46.0487 33.8851 46.2333 31.3671 45.6853 28.9834C45.1373 26.5996 43.8879 24.4857 42.1342 22.9755C40.3806 21.4652 38.2226 20.6444 36.0009 20.6428H33.4809C32.8755 18.0504 31.7472 15.6437 30.1808 13.6036C28.6144 11.5635 26.6506 9.94306 24.4371 8.86417C22.2236 7.78527 19.818 7.27597 17.4011 7.37456C14.9843 7.47315 12.619 8.17706 10.4833 9.43337C8.34747 10.6897 6.49672 12.4657 5.07014 14.6279C3.64356 16.7901 2.67828 19.2822 2.24686 21.9169C1.81544 24.5516 1.92911 27.2603 2.57932 29.8393C3.22954 32.4184 4.39938 34.8007 6.0009 36.8071",
    stroke: "black",
    strokeOpacity: 0.4,
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M32 36.1428L24 27.2856L16 36.1428",
    stroke: "black",
    strokeOpacity: 0.4,
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFeatherUploadCloudIcon);
export default __webpack_public_path__ + "static/media/feather_upload-cloud-icon.e54cc3a8cf60904907097b3c26a6305c.svg";
export { ForwardRef as ReactComponent };